import React, { useState } from "react";
import {
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Slide,
  Toolbar,
} from "@mui/material";
import {
  Close as CloseIcon,
  ContentCut as ContentCutIcon,
  Delete as DeleteIcon,
  Download as DownloadIcon,
  DriveFileMove as DriveFileMoveIcon,
  MoreHoriz as MoreHorizIcon,
} from "@mui/icons-material";

function MultiSelectToolbar({
  multiSelected,
  onClose,
  onDownload,
  onRename,
  onDelete,
  onShare,
  onMove,
  onCut,
  readOnly,
  busy,
}: {
  multiSelected: string[] | null;
  onClose: () => void;
  onDownload: () => void;
  onRename: () => void;
  onDelete: () => void;
  onShare: () => void;
  onMove: () => void;
  onCut: () => void;
  readOnly?: boolean;
  busy?: boolean;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <Slide direction="up" in={multiSelected !== null}>
      <Toolbar
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          backgroundColor: (theme) => theme.palette.background.paper,
          borderTop: "1px solid lightgray",
          justifyContent: "space-evenly",
        }}
      >
        <IconButton
          aria-label="Close selection"
          color="primary"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        {!readOnly && (
          <React.Fragment>
            <IconButton
              color="primary"
              disabled={
                multiSelected?.length !== 1 || multiSelected[0].endsWith("/")
              }
              onClick={onDownload}
            >
              <DownloadIcon />
            </IconButton>
            <IconButton
              aria-label="Delete"
              color="primary"
              disabled={busy}
              onClick={onDelete}
            >
              <DeleteIcon />
            </IconButton>
            <IconButton
              color="primary"
              aria-label="More actions"
              disabled={busy || !multiSelected?.length}
              onClick={(e) => setAnchorEl(e.currentTarget)}
            >
              <MoreHorizIcon />
            </IconButton>
          </React.Fragment>
        )}
        {!readOnly && multiSelected?.length && (
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            {multiSelected.length === 1 && (
              <MenuItem disabled={busy} onClick={onRename}>
                Rename
              </MenuItem>
            )}
            {multiSelected.length === 1 && (
              <MenuItem onClick={onShare}>Share</MenuItem>
            )}
            <MenuItem
              disabled={busy}
              onClick={() => {
                setAnchorEl(null);
                onMove();
              }}
            >
              <ListItemIcon>
                <DriveFileMoveIcon fontSize="small" />
              </ListItemIcon>
              Move to...
            </MenuItem>
            <MenuItem
              disabled={busy}
              onClick={() => {
                setAnchorEl(null);
                onCut();
              }}
            >
              <ListItemIcon>
                <ContentCutIcon fontSize="small" />
              </ListItemIcon>
              Cut
            </MenuItem>
          </Menu>
        )}
      </Toolbar>
    </Slide>
  );
}

export default MultiSelectToolbar;
